import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Typename, ComponentRefById } from './../pages.interfaces';
import { HttpClientService } from '../../essentials/http/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class PreviewService extends HttpClientService {
  public host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {
    super(http);
  }

  public getPage(slug: string): Observable<ComponentRefById[]> {
    return this.getPageComponents(slug).pipe(
      map((res) => this.extractResult(res) ),
      catchError((error) => {
        if (!environment.production) {
          console.log(error);
        }
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.body.data.queryPaginasContents[0].flatData.componentes.filter(
      (item) => {
        if (item.__typename) {
          return item;
        }
      }
    );
  }

  private getPageComponents(slug: string): Observable<Typename[]> {
    const payload = {
      query: `
        {
          queryPaginasContents(filter: "data/slug/iv eq '${slug}'") {
            flatData {
              componentes {
                ... on NewBanners {
                  __typename
                  id
                }
                ... on Banners {
                  __typename
                  id
                }
                ... on DestaqueNavegacao {
                  __typename
                  id
                }
                ... on NoticiasCarrossel {
                  __typename
                  id
                  flatData {
                    title
                    max
                    labelLink
                  }
                }
                ... on Servicos {
                  __typename
                  id
                }
                ... on Beneficios {
                  __typename
                  id
                }
                ... on Formulario {
                  __typename
                  id
                }
                ... on ServicosGrupo {
                  __typename
                  id
                }
                ... on Vantagens {
                  __typename
                  id
                }
                ... on Certificacoes {
                  __typename
                  id
                  data {
                    title { iv }
                    subtitle { iv }
                    img { iv { url } }
                  }
                }
                ... on Contadores {
                  __typename
                  id
                }
                ... on Social {
                  __typename
                  id
                }
                ... on Taxas {
                  __typename
                  id
                }
                ... on Informativo {
                  __typename
                  id
                }
                ... on CardIconeTituloLink {
                  __typename
                  id
                }
                ... on IconeTitulo {
                  __typename
                  id
                }
                ... on DescricaoCorFundo {
                  __typename
                  id
                }
                ... on ImagemTituloDescricao {
                  __typename
                  id
                }
                ... on Imagem {
                  __typename
                  id
                }
                ... on LinkInternoVoltar {
                  __typename
                  id
                }
                ... on TituloSubtituloCorFundo {
                  __typename
                  id
                }
                ... on UnidadesClinica {
                  __typename
                  id
                }
                ... on BannerTextoGrande {
                  __typename
                  id
                }
                ... on PaginasIncorporadas {
                  __typename
                  id
                  flatData {
                    titulo
                    subtitulo
                    urlIframe
                  }
                }
                ... on DestaquePlanosSaude {
                  __typename
                  id
                }
                ... on Graficos {
                  __typename
                  id
                }
                ... on Secao {
                  __typename
                  id
                }
                ... on Faq {
                  __typename
                  id
                }
              }
            }
          }
        }`,
    };

    return this.send(payload);
  }

  public getConfigOtherInsurance(): Observable<any> {
    return this.configOtherInsurance().pipe(
      map((res) => res.data.queryConfiguracaoOutrosSegurosContents[0].flatData),
      catchError((error) => {
        if (!environment.production) {
          console.log(error);
        }
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private configOtherInsurance(): Observable<any> {
    const payload = {
      query: `
        {
          queryConfiguracaoOutrosSegurosContents {
            flatData{
              title
              subtitle
            }
          }
        }`,
    };

    return this.send(payload);
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.post(url, payload, 'preview');
  }
}
